<template>
    <div id="works" class="works related-works">
      <transition-group name="fade" mode="in-out">
            <WorkTile v-for="(work, index) in this.works" :key="'work-'+index" class="work" :work="work"></WorkTile>
      </transition-group>
    </div>
</template>

<script>
import axios from 'axios';
import WorkTile from './components/WorkTile'

export default {
  name: 'Work',
  data() {
    return {
      works: [],
    }
  },
  components: {
    WorkTile
  },
  mounted() {
    let expertise = ''
    if(window.expertiseId)
     expertise = `&expertise=${window.expertiseId}`
    axios.get(`${window.location.origin}/wp-json/wp/v2/work?_embed&per_page=3${expertise}`)
    .then(response => {
      this.works = response.data
    })
  },
}
</script>

<style scoped lang="scss">
.works span {
  display: flex;
  flex-wrap: wrap;
}
.work {
  text-align: left;
  flex-basis: 100%;
  position: relative;
  height: 40vw;
  font-family: "Circular std book", Sans-serif;

  @media screen and (min-width: 640px) {
    flex-basis: 33.33%;
    height: 25vw;
  }
}
.work:hover .work-overlay,
.work:hover .work-content {
  opacity: 1;
  transition: all 0.3s ease-in-out;
}
.work-overlay {
  opacity: 0;
  width: 100%;
  height: 100%;
  position: absolute;
  bottom: 0;
  right: 0;
  background: rgba(0,0,0,0.5);
}
.work .work__image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.work .work__type {
  font-size: 35px;
  margin-top: 0;
  margin-bottom: 0.25em;
  font-family: inherit;
}
.work .work__client {
  font-size: 18px;
  margin-top: 0;
  margin-bottom: 0;
  font-family: inherit;
}
</style>
